// data-testid registry for Bombay Bespoke Fashion House website

export const NAV = {
  root: 'nav-root',
  logo: 'nav-logo',
  home: 'nav-home',
  womens: 'nav-womens-design',
  mens: 'nav-mens-bespoke',
  story: 'nav-our-story',
  appointment: 'nav-book-appointment',
  contact: 'nav-contact',
  mobileToggle: 'nav-mobile-toggle',
  mobileSheet: 'nav-mobile-sheet',
};

export const FLOATING = {
  whatsapp: 'floating-whatsapp-btn',
  call: 'floating-call-btn',
};

export const FOOTER = {
  root: 'site-footer',
  instagram: 'footer-instagram',
  tiktok: 'footer-tiktok',
  email: 'footer-email',
  phone: 'footer-phone',
  address: 'footer-address',
};

export const HOME_PAGE = {
  hero: 'home-hero',
  heroCta: 'home-hero-book-cta',
  womensPreview: 'home-womens-preview',
  womensCta: 'home-womens-explore-cta',
  mensPreview: 'home-mens-preview',
  mensCta: 'home-mens-explore-cta',
  craftsmanship: 'home-craftsmanship',
  visitCta: 'home-visit-cta',
};

export const WOMENS_PAGE = {
  root: 'womens-page',
  hero: 'womens-hero',
  categoryCard: (slug) => `womens-category-${slug}`,
  bookCta: 'womens-book-cta',
};

export const MENS_PAGE = {
  root: 'mens-page',
  hero: 'mens-hero',
  categoryCard: (slug) => `mens-category-${slug}`,
  bookCta: 'mens-book-cta',
};

export const STORY_PAGE = {
  root: 'story-page',
  founderGill: 'story-founder-gill',
  founderVandana: 'story-founder-vandana',
  howWeWorkStep: (n) => `story-process-step-${n}`,
};

export const APPOINTMENT_PAGE = {
  root: 'appointment-page',
  form: 'appointment-form',
  inputName: 'appointment-input-name',
  inputPhone: 'appointment-input-phone',
  inputEmail: 'appointment-input-email',
  service: 'appointment-service',
  serviceOption: (val) => `appointment-service-${val}`,
  datePickerBtn: 'appointment-date-picker',
  calendar: 'appointment-calendar',
  inputTime: 'appointment-input-time',
  inputOccasion: 'appointment-input-occasion',
  inputMessage: 'appointment-input-message',
  submit: 'appointment-submit',
  success: 'appointment-success',
  whatsappFallback: 'appointment-whatsapp-fallback',
};

export const CONTACT_PAGE = {
  root: 'contact-page',
  form: 'contact-form',
  inputName: 'contact-input-name',
  inputEmail: 'contact-input-email',
  inputPhone: 'contact-input-phone',
  inputSubject: 'contact-input-subject',
  inputMessage: 'contact-input-message',
  submit: 'contact-submit',
  success: 'contact-success',
  callBtn: 'contact-call-btn',
  whatsappBtn: 'contact-whatsapp-btn',
  directionsBtn: 'contact-directions-btn',
};

export const COMING_SOON = {
  root: 'coming-soon-page',
  backHome: 'coming-soon-back-home',
};
